module.exports = __webpack_public_path__ + "static/media/cigar1.36fb1748.jpg";